<template>
  <VTransitionCollapse class="v-errors" lazy :visible>
    <slot :errors name="errors">
      <div v-for="message in errors" :key="message" class="v-error" v-text="message" />
    </slot>
  </VTransitionCollapse>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import VTransitionCollapse from './VTransitionCollapse.vue'

interface Props {
  errors: string[]
}

const props = defineProps<Props>()

defineSlots<{
  errors?: (props: { errors: string[] }) => any
}>()

const visible = ref(false)

watch(
  () => props.errors.length,
  (length) => (visible.value = length > 0),
  { immediate: true },
)
</script>

<style>
.v-errors {
  padding: 0 8px;
}

.v-error {
  color: var(--color-red);
  font-size: 12px;
  position: relative;
  white-space: pre-wrap;
}
</style>
